<template>
    <div class="chapter">
        <headers :title='title'></headers>
        <template v-if="loading">
            <template v-if="!Object.keys(book).length">
                <div class="no-book">
                    <p class="p1"></p>
                    <p class="p2">您暂未设置<em>教材</em></p>
                    <p class="p3">请设置一本<em>教材</em>吧，设置过后才能布置作业</p>
                    <a href="javascript:;"
                       class="set-book"
                       @click="setbook">设置教材</a>
                </div>
            </template>
            <template v-else>
                <div class="title">
                    <i class="icon-book"></i>
                    <p>{{book.book_name}}</p>
                    <a href="javascript:;"
                       class="set-book"
                       @click="setbook">更换<em>教材</em><i class="enter"></i></a>
                </div>
                <div class="list"
                     v-if="list.length">
                    <div class="list-box"
                         v-for="(l,lind) in list">
                        <div :class="[lind?'list_con':'list_con first_border']">
                            <i class="list_book"></i>
                            <p>{{lind+1}}.{{l.chapter_name}}</p>
                            <i :class="l.choise ? 'list_active' : 'list_noactive'"
                               @click="select(l,true)"></i>
                        </div>
                    </div>

                </div>
                <noResouse v-else></noResouse>
                <div class="bottom_btn">
                    <a class="btn_a"
                       v-if='catalogId.length'
                       @click='next'>下一步</a>
                    <a v-else>下一步</a>
                </div>
            </template>
        </template>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue';
import loadingS from 'COMPONENTS/base/tealoading.vue';
import noResouse from 'COMPONENTS/noResouse.vue';

export default {
    data () {
        return {
            title: '',
            loading: false,//接口是否返回数据
            list: [],
            book: {},
            catalogId: [],//选中的章节id,先利用Object的特性处理选中的数据，最后用Object.values()转换为数组
            next_btn: false,
            sid: 24,
            type: 0,
            book_type: 0,
            code: '021',
        }
    },
    components: {
        headers, loadingS, noResouse
    },
    created () {
        this.title = '围棋课后练习';
        this.$http.post(API_URL_TASK_API + '/public/book/user_book', {
            sid: this.sid,
            book_type: this.type,
            code: this.code
        }).then(res => {
            res = res.data;
            if (res.response == 'ok') {
                this.book = res.data;
                if (Object.keys(this.book).length) {
                    this.getList(71);
                } else {
                    this.loading = true;
                }
            }
        })
    },
    methods: {
        setbook () {
            this.$router.push('/weiqi/setBook/' + this.sid + '/' + this.type + '/' + this.code)
        },
        next () {
            let ids = []
            this.list.forEach(e => {
                if (e.choise) {
                    ids.push(e.chapter_id)
                }
            })
            localStorage.setItem('ch_id', ids.join(','))
            this.$router.push('/weiqi/preview');
        },
        select (l, flag) {
            l.choise = !l.choise;
            this.list.splice(0, 1, this.list[0]);
            if (flag) {
                if (l.choise) {
                    this.catalogId.push(l.ch_id);
                } else {
                    this.catalogId.forEach((v, i) => {
                        if (v === l.ch_id) {
                            this.catalogId.splice(i, 1);
                        }
                    })
                }
            }
        },
        getList (course_id) {
            this.$http.post(API_URL_TASK_API + '/weiqi/chapter/', { course_id, course_id }).then(res => {
                res = res.data;
                if (res.response === 'ok') {
                    this.loading = true;
                    this.list = res.data.chapter_info;
                    this.list.forEach(item => {
                        item.choise = false;
                    })
                }
            })
        }
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.chapter {
    padding-bottom: 96px / $ppr;
    min-height: 100vh;
    box-sizing: border-box;

    .no-book {
        //无教材
        margin-top: 325px / $ppr;
        width: 100%;
        height: auto;
        .p1 {
            margin: 0 auto;
            width: 136px / $ppr;
            height: 112px / $ppr;
            background: url("./img/icon_nobook.png") no-repeat;
            -webkit-background-size: 100% 100%;
            background-size: 100% 100%;
        }
        .p2 {
            width: 100%;
            text-align: center;
            color: #333;
            font-size: 36px / $ppr;
            line-height: 36px / $ppr;
            margin: 40px / $ppr 0 16px / $ppr 0;
        }
        .p3 {
            width: 100%;
            text-align: center;
            color: #999;
            font-size: 24px / $ppr;
            line-height: 24px / $ppr;
            margin-bottom: 40px / $ppr;
        }
        .set-book {
            display: block;
            margin: 0 auto;
            width: 360px / $ppr;
            height: 82px / $ppr;
            line-height: 82px / $ppr;
            text-align: center;
            font-size: 34px / $ppr;
            color: #fff;
            border-radius: 40px / $ppr;
            background: #5e89ef;
        }
    }
    .title {
        margin-bottom: 24px / $ppr;
        padding: 0 24px / $ppr;
        height: 96px / $ppr;
        background: #fff;
        .icon-book {
            display: block;
            float: left;
            margin: 31px / $ppr 24px / $ppr 0 0;
            width: 34px / $ppr;
            height: 34px / $ppr;
            background: url("./img/icon_setbook.png") no-repeat;
            background-size: 100% 100%;
        }
        p {
            float: left;
            width: 400px / $ppr;
            line-height: 96px / $ppr;
            font-size: 30px / $ppr;
            color: #333;
            @include ellipsis;
        }
        .set-book {
            position: relative;
            display: block;
            float: right;
            padding-right: 30px / $ppr;
            line-height: 96px / $ppr;
            font-size: 30px / $ppr;
            color: #5e89ef;
            .enter {
                display: block;
                position: absolute;
                top: 50%;
                right: 0;
                margin-top: -13px / $ppr;
                width: 14px / $ppr;
                height: 26px / $ppr;
                background: url("./img/enter.png") no-repeat;
                background-size: 100% 100%;
            }
        }
    }
    .list {
        background: #fff;
        width: 100vw;
        overflow: hidden;
        .list_children {
            background: #f0f0f0;
        }
        .list_con,
        .list_children {
            position: relative;
            padding: 0 24px / $ppr;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            border-top: 1px / $ppr solid #e8e8e8;
            display: flex;
            align-items: center;
            overflow: hidden;
            &.first_border {
                border-top: none;
            }
            .list_book {
                display: block;
                width: 34px / $ppr;
                height: 32px / $ppr;
                background: url("./img/icon_book.png") no-repeat;
                background-size: 100% 100%;
            }
            p {
                font-size: 30px / $ppr;
                color: #333;
                @include ellipsis;
                flex: 1 1 0%;
                padding: 0 24px / $ppr;
            }
            .list_active {
                display: block;
                width: 40px / $ppr;
                height: 40px / $ppr;
                background: url("./img/icon_select.png") no-repeat;
                background-size: 100% 100%;
            }
            .list_noactive {
                display: block;
                width: 40px / $ppr;
                height: 40px / $ppr;
                background: url("./img/icon_unchecked.png") no-repeat;
                background-size: 100% 100%;
            }
            .list_open {
                display: block;
                position: absolute;
                right: 24px / $ppr;
                top: 50%;
                margin-top: -6.5px / $ppr;
                width: 25px / $ppr;
                height: 13px / $ppr;
                background: url("./img/icon_open.png") no-repeat;
                background-size: 100% 100%;
            }
            .list_close {
                display: block;
                position: absolute;
                right: 24px / $ppr;
                top: 50%;
                margin-top: -6.5px / $ppr;
                width: 25px / $ppr;
                height: 13px / $ppr;
                background: url("./img/icon_close.png") no-repeat;
                background-size: 100% 100%;
            }
        }
    }
    .bottom_btn {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100vw;
        a {
            display: inline-block;
            width: 100%;
            height: 97px / $ppr;
            line-height: 97px / $ppr;
            text-align: center;
            font-size: 36px / $ppr;
            //font-weight: bold;
            color: #999999;
            background-color: $line;
            &.btn_a {
                color: #fff;
                background-color: #5e89ef;
            }
        }
    }
}
.list_children_wrap {
    height: 0;
    overflow: hidden;
    transition: height 0.3s linear;
}
.my-slide-enter,
.my-slide-leave-to {
    height: 0 !important;
}
</style>
